import React from 'react';

const PaymentDataContext = React.createContext();

export default PaymentDataContext;